import { type ReactElement, type ReactNode } from 'react';

type Props = {
  title: string;
  description?: string;
  children: ReactNode;
};

export function Section({ title, description, children }: Props): ReactElement {
  return (
    <section>
      <header>
        <h3 className="text-base font-semibold text-foreground">{title}</h3>
        {description && (
          <p className="mt-1 text-[13px] text-muted-foreground">
            {description}
          </p>
        )}
      </header>
      <div className="mt-4">{children}</div>
    </section>
  );
}
